import React, { Component } from 'react';
import { connect } from 'react-redux';
import {withRouter} from 'react-router-dom';

import {withError} from 'modules/misc/ErrorPage.js';
import {initNavbarState, setNavbarTitle} from 'actions/navbar.js';
import {fetchTimeline} from 'actions/timeline.js';
import {fetchChallenge} from 'actions/challenges.js';
import {getChallengeWithCategory} from 'reducers';
import {completeChallenge} from 'actions/userChallenges.js';
import {userCategoryUpdateLevel} from 'actions/categories.js';
import Utils from 'utils/Utils.js';
import LoadInline from 'modules/loading/LoadInline.js';

import ReadConfirmChallengeContainer   from './types/ReadConfirmChallengeContainer.js';
import TimedChallengeContainer   from './types/TimedChallengeContainer.js';
import TimedLogChallengeContainer   from './types/TimedLogChallengeContainer.js';
import CountUpChallengeContainer   from './types/CountUpChallengeContainer.js';
import MCQChallengeContainer   from './types/MCQChallengeContainer.js';
import InputChallengeContainer from './types/InputChallengeContainer.js';
import DoubleLogChallengeContainer from './types/DoubleLogChallengeContainer.js';
import TimedDoubleLogChallengeContainer from './types/TimedDoubleLogChallengeContainer.js';
import WaterChallengeContainer   from './types/WaterChallengeContainer.js';
import AllDayWithMaxChallengeContainer   from './types/AllDayWithMaxChallengeContainer.js';
import AllDayChallengeContainer   from './types/AllDayChallengeContainer.js';
import StepsChallengeContainer   from './types/StepsChallengeContainer.js';
import PhotoChallengeContainer   from './types/PhotoChallengeContainer.js';
import PhotoLogChallengeContainer   from './types/PhotoLogChallengeContainer.js';
import PhotoMCQChallengeContainer   from './types/PhotoMCQChallengeContainer.js';
import ImageChallengeContainer   from './types/ImageChallengeContainer.js';
import ImageLogChallengeContainer   from './types/ImageLogChallengeContainer.js';
import ImageMCQChallengeContainer   from './types/ImageMCQChallengeContainer.js';
import UnknownChallenge from './types/UnknownChallenge.js';

const LoadInlineWithError = withError(LoadInline);

const ComponentsByType = {
    1:  ReadConfirmChallengeContainer,
    2:  TimedChallengeContainer,
    3:  WaterChallengeContainer,
    4:  StepsChallengeContainer,
    5:  PhotoChallengeContainer,
    6:  CountUpChallengeContainer, 
    7:  TimedLogChallengeContainer,
    8:  PhotoLogChallengeContainer,
    9:  AllDayWithMaxChallengeContainer,
//  10: VIDEO - not ready yet on back end
    11: MCQChallengeContainer,
    12: DoubleLogChallengeContainer,
    13: TimedDoubleLogChallengeContainer,
    14: AllDayChallengeContainer,
    15: ImageChallengeContainer,
    16: PhotoMCQChallengeContainer,
    17: ImageLogChallengeContainer,
    18: ImageMCQChallengeContainer,
    19: InputChallengeContainer,
//  20: MULTIPLE_SELECTION - on hold - current temporary solution stephan no longer likes
}

/*
var TYPES = {
        SINGLE_ACTION : 1,
        TIMER : 2,
        WATER : 3,
        STEPS : 4,
        PHOTO : 5,
        TIMER_COUNT_UP : 6, //-- integer in ms
        TIMER_INPUT : 7, //-- increment
        PHOTO_INPUT : 8, //-- photo + integer
        MULTI_ACTION : 9, //increment
        VIDEO : 10, // -- increment
        MULTIPLE_CHOICE : 11, // -- integer
        DIFFERENTIAL : 12, //-- integer
        TIMER_DIFFERENTIAL : 13, //integer
        UNLIMITED : 14,
        IMAGE : 15,
        PHOTO_MCQ : 16,
        IMAGE_INPUT : 17,
        IMAGE_MCQ : 18,
        INPUT : 19,
        MULTIPLE_SELECTION : 20
    };
*/

function getChallengeId(props) {
    return props.challengeId || props.match.params.id;
}

class Challenge extends Component {
    constructor(props){
        super(props);
        this.complete = false;
        this.completePending = false;
        this.state = {busy:false, complete:false, completePending:false};
        this.onComplete = this.onComplete.bind(this);
        this.onContinue = this.onContinue.bind(this);
        this.onRepeatLevel= this.onRepeatLevel.bind(this);
    }
    componentWillMount() {
        var challengeTitle    = Utils.deref(this.props, 'challenge.title','');
        this.props.dispatch(initNavbarState({enable:true, title:challengeTitle, menuEnable:false, backButtonEnable:true}));
        this.props.dispatch({type:'SET_SIDEBAR_ENABLE', enable:false});
        this.loadData();
    }

    componentWillReceiveProps(newProps) {
        if(newProps.title!==this.props.title) {
            this.props.dispatch(setNavbarTitle(newProps.title));
        }
    }

    loadData() {
        this.setState({busy:true});
        this.props.loadData(getChallengeId(this.props))
            .catch((error)=> {
                console.error('ERROR:');
                console.error(error);
                    this.setState({error:error});
            })
            .then(()=>{
                this.setState({busy:false});
            });
    }


    getComponentByType(type) {
        return ComponentsByType.hasOwnProperty(type) ? ComponentsByType[type] : UnknownChallenge;
    }

    onComplete(challengeId, userChallenge, params) {
        if(!this.completePending) {
            this.completePending = true;
            this.setState({completePending:this.completePending});
            this.props.dispatch({type:'SET_LOADING_OVERLAY_ENABLE', enable:true});
            params = params || {};
            if(this.props.userProfileIds && this.props.userProfileIds.length>0) {
                params.record = params.record || {};
                params.record.userProfileIds = this.props.userProfileIds;
            }
            if(this.props.seasonId) {
                params.record = params.record || {};
                params.record.seasonId = this.props.seasonId;
            }
            if(this.props.challengeRecordId) {
                params.challengeRecordId = this.props.challengeRecordId;
            }
            return this.props.completeChallenge(challengeId, userChallenge, params)
                .then(({userChallenge, progress})=>{//always
                    this.complete = (userChallenge.state==1);
                    this.userChallenge = userChallenge;
                    this.progress = progress;
                    console.log("challenge.onComplete result: ", userChallenge, progress);
                    this.props.refreshDependencies().catch((error)=>console.error('error fetching history', error));
                })
                .catch((error)=>{
                    console.error(error);
                    window.alert("Error: " + error);
                })
                .then(()=>{//always
                    this.completePending = false;
                    if(this.userChallenge) {
                        if(this.userChallenge.challengeRecordId) {
                            if(this.props.teamChallengeData.replacePageOnComplete) {
                                this.props.history.replace('/myteamchallenge/'+this.userChallenge.challengeRecordId);
                            } else {
                                this.props.history.push('/myteamchallenge/'+this.userChallenge.challengeRecordId);
                            }
                        } else {
                            this.setState({ completePending:this.completePending, 
                                            complete:this.complete, 
                                            userChallenge:this.userChallenge,
                                            progress:this.progress});
                        }
                    }
                    this.props.dispatch({type:'SET_LOADING_OVERLAY_ENABLE', enable:false});
                });
        }
        return Promise.resolve(null);
    }

    onContinue() {
        if(this.props.onContinue) {
            this.props.onContinue();
        } else {
            //default behavior?
            this.props.history.push('/home');
        }
    }
    onRepeatLevel() {
        //Resubscribe to current level
        var userChallenge = this.userChallenge;
        var userCategory = userChallenge ? userChallenge.userCategory : null;
        var categoryId = userCategory ? userCategory.categoryId : null;
        var progress = this.progress;
        if(categoryId!=null && progress!=null) {
            var level = progress.level;
            this.props.userCategoryUpdateLevel(categoryId, level)
                .catch( error => {
                    console.error('userCategoryUpdateLevel - ', error);
                })
                .then(this.onContinue);
        } else {
            console.error('onRepeatLevel - unable to determine level or categoryId', {userChallenge, progress});
            this.onContinue();
        }
    }

    render() {
        var challenge = this.props.challenge;
        if(this.state.busy || challenge==null || this.state.error) {
            return <LoadInlineWithError error={this.state.error} centered vcentered />; //TODO - handle loading and missing cases
        }
        var ChallengeComponent = this.getComponentByType(challenge.type); 
        return (
            <ChallengeComponent challenge={challenge} 
                                onComplete={this.onComplete} 
                                onRepeatLevel={this.onRepeatLevel}
                                onContinue={this.onContinue}
                                completePending={this.state.completePending} 
                                complete={this.state.complete}
                                userChallenge={this.state.userChallenge}
                                teamChallengeData={this.props.teamChallengeData}
                                progress={this.state.progress} />
            );
    }

}


const mapStateToProps = (state, ownProps) => {
    var challenge = getChallengeWithCategory(state, getChallengeId(ownProps));
    var title = challenge ? challenge.title : '';
    return {challenge,title};
};

const mapDispatchToProps = (dispatch) => {
    return {
        completeChallenge: (challengeId, userChallenge, params) => dispatch(completeChallenge(challengeId, userChallenge, params)),
        loadData: (id) => dispatch(fetchChallenge(id)),
        userCategoryUpdateLevel: (id, level) => dispatch(userCategoryUpdateLevel(id,level)),
        refreshDependencies: () => Promise.all([dispatch(fetchTimeline())]),
        dispatch: dispatch
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Challenge));



// WEBPACK FOOTER //
// ./src/modules/challenges/Challenge.js